// extracted by mini-css-extract-plugin
export default {"mainHeader":"OnlineDoctor_mainHeader__dPQTA"};